import { RESET_SERVICE_ERRORS } from '../errors/actionTypes';
import { validateTrimData } from 'store/reducers/appointment/actions';
import { getPackages } from 'store/reducers/packages/actions';
import { getMaintenanceServices } from 'store/reducers/maintenance/actions';
import { getRepairServices } from 'store/reducers/repair/actions';
import {
  getRecallDeferredServices,
  setRecallServices
} from 'store/reducers/recall/actions';
import { getDeclinedServices } from 'store/reducers/declined/actions';
import { setDeferredServices } from 'store/reducers/deferred/actions';
import { setReadOnlyServices } from 'store/reducers/quoteAppt/actions';

// selectors
import { getReadOnlyServices } from 'store/reducers/quoteAppt/selectors';

export const loadServices = neededServiceAwait => async dispatch => {
  dispatch({
    type: RESET_SERVICE_ERRORS
  });
  dispatch(validateTrimData());
  neededServiceAwait ? await dispatch(getPackages()) : dispatch(getPackages());

  const recallServices = await dispatch(getRecallDeferredServices());
  if (recallServices) {
    const { recallInfo, deferredServices } = recallServices;
    let recallServiceRetry;
    if (recallInfo && recallInfo.autoRecalls.length < 1) {
      recallServiceRetry = await dispatch(getRecallDeferredServices());
    }

    const autoRecallsNoRetry = recallInfo && recallInfo.autoRecalls;
    const autoRecallsRetry =
      recallServiceRetry &&
      recallServiceRetry.recallInfo &&
      recallServiceRetry.recallInfo.autoRecalls;

    const autoRecalls =
      autoRecallsNoRetry && autoRecallsNoRetry.length > 0
        ? autoRecallsNoRetry
        : autoRecallsRetry;

    autoRecalls &&
      dispatch(
        setRecallServices(
          autoRecalls.filter(
            recall =>
              ['COMPLETED', 'CLOSED'].indexOf(recall.status) === -1 &&
              recall.customerVisible
          )
        )
      );
    deferredServices && dispatch(setDeferredServices(deferredServices));
  }
  neededServiceAwait
    ? await dispatch(getMaintenanceServices())
    : dispatch(getMaintenanceServices());
  await dispatch(getRepairServices());
  await dispatch(getDeclinedServices());
};

export const updateReadOnlyServices = selectedService => async (
  dispatch,
  getState
) => {
  const readOnlyServices = getReadOnlyServices(getState());
  const updatedQuoteServices =
    readOnlyServices &&
    readOnlyServices.map(service => {
      if (selectedService.quoteServiceId === service.quoteServiceId) {
        return {
          ...service,
          selected: !service.selected
        };
      }
      return service;
    });

  dispatch(setReadOnlyServices(updatedQuoteServices));
};



// WEBPACK FOOTER //
// ./src/store/reducers/service/actions.js